// @flow
import React from 'react';
import ContentLoader from 'react-content-loader';
import './StatusTrackerPage.scss';

const StatusTrackerPageLoader = () => {
  return (
    <ContentLoader height={340}>
      <rect className="placeholder-rect-title" />
      <rect className="placeholder-rect-progress-bar-label" />
      <rect className="placeholder-rect-progress-bar-panel" />
      <rect className="placeholder-rect-contact-info-label" />
      <rect className="placeholder-rect-contact-info-panel" />
      <rect className="placeholder-rect-disclaimer-panel" />
    </ContentLoader>
  );
};

export default StatusTrackerPageLoader;



// WEBPACK FOOTER //
// ./src/components/pages/StatusTrackerPage/StatusTrackerPageLoader.js